export enum AuthorisationPermissions {
    ModuleCode = 'Authorisation',
    AuthorisationAccessCode = 'Authorisation_Access',
    WriteUsersGroupsCode = 'Authorisation_WriteUsersGroups'
}
